// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface PandaDocConfigOut {}

export const PandaDocConfigOutSerializer = {
  _fromJsonObject(_object: any): PandaDocConfigOut {
    return {};
  },

  _toJsonObject(_self: PandaDocConfigOut): any {
    return {};
  },
};
